import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem("ns_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("ns_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.two_factor_required) {
      return {
        two_factor_required: true,
        challenge_id: data.challenge_id,
        email: data.email,
      };
    }
    localStorage.setItem("ns_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const verify2fa = async (challenge_id, code) => {
    const { data } = await api.post("/auth/verify-2fa", { challenge_id, code });
    localStorage.setItem("ns_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ns_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, verify2fa, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
